import styled from "styled-components";
import Image from "../../assets/image/image";

const MainRouterContainer = styled.div`
  width: 100%;
  text-align: center;
  .MainContainer {
    min-height: 67vh;
  }
  .DefaultRoute {
    background: repeat url(${Image.mainbannerbackground});
    height: 53.1vh;
    z-index: 1;
    display: flex;
    h1 {
      align-items: center;
      margin: auto;
      font-family: "Do Hyeon", sans-serif;
    }
  }
  @media only screen and (max-width: 480px) {
    .DefaultRoute {
      background: none;
      height: 30.2vh;
    }
    .ChangeRoute {
      width: 100%;
      margin: 0;
    }
    .MainContainer {
      img {
        width: 100%;
      }
      .MainBannerLeft,
      .MainBannerRight {
        display: none;
      }
    }
  }
`;

export default MainRouterContainer;
